import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSpinRight20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconArrowSpinRight20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.913 17.152a.75.75 0 0 0 1.5 0v-.515c.61.584 1.388 1.044 2.167 1.375 1.46.62 3.194.913 4.537.679 2.432-.424 4.042-1.362 4.675-1.993a.75.75 0 0 0-1.059-1.062c-.356.355-1.652 1.189-3.874 1.576-.983.172-2.418-.04-3.692-.58-.9-.383-1.592-.873-2.005-1.392l1.13.216a.75.75 0 0 0 .281-1.474l-2.77-.53-.89-.17zm7.104-10.623a3.49 3.49 0 1 0 0 6.98l.18-.006a3.49 3.49 0 0 0-.18-6.974m0 1.5a1.99 1.99 0 1 1 0 3.98 1.99 1.99 0 0 1 0-3.98m3.42-6.005c-1.461-.62-3.194-.913-4.538-.679-2.431.424-4.042 1.362-4.674 1.993A.75.75 0 0 0 5.283 4.4c.356-.355 1.653-1.189 3.874-1.576.984-.172 2.418.04 3.693.58.899.383 1.592.873 2.005 1.392l-1.13-.216a.75.75 0 0 0-.282 1.474l2.77.53.89.17v-3.87a.75.75 0 0 0-1.5 0V3.4c-.61-.585-1.388-1.044-2.166-1.375"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowSpinRight20);
